import VisaLogo from "@/res/logos/visa-logo.png";
import MasterCard from "@/res/logos/mastercard-logo.png";
import AmericanExpress from "@/res/logos/amex-logo.png";
import PayPal from "@/res/logos/PayPal_Logo_2022/PayPal_Logo_Horizontal_Full_Color_RGB.png";
import GooglePay from "@/res/logos/Google-Pay-Mark/google-pay-logo.png";
import ApplePay from "@/res/logos/Apple-Pay-Mark/apple-pay-logo.png";
import PayInfour from "@/res/logos/PayPal_Payin4.png";
import PayTo from "@/res/logos/payto-logo.png";
import KlarnaLogo from "@/res/logos/klarna-logo.svg?url";
import AfterpayLogo from "@/res/logos/afterpay-logo.png";

import { Wallet } from "lucide-react";
import { cn } from "@/util/cn";
import { Link } from "react-router";

export type PaymentMethodType = {
  name: string;
  logo: JSX.Element;
  link?: string;
};

export const paymentMethods: PaymentMethodType[] = [
  {
    name: "Apple Pay",
    logo: (
      <img
        src={ApplePay}
        alt="Apple Pay Logo"
        className="h-6 md:h-8 max-w-full"
      />
    ),
  },
  {
    name: "Google Pay",
    logo: (
      <img src={GooglePay} alt="Google Pay Logo" className="h-6 md:h-8 max-w-full" />
    ),
  },
  {
    name: "PayPal",
    logo: (<img src={PayPal} alt="PayPal Logo" className=" max-w-full p-2" />),
  },
  {
    name: "Paypal Pay in 4",
    logo: (
      <img src={PayInfour} alt="Paypal Pay in 4 Logo" className="max-w-full p-2" />
    ),
  },
  {
    name: "PayTo",
    logo: (
      <img src={PayTo} alt="PayTo Logo" className="max-w-full max-h-full p-2" />
    ),
  },
  {
    name: "Klarna",
    logo: (
      <img src={KlarnaLogo} alt="Klarna Logo" className="h-6 md:h-8 max-w-full" />
    ),
  },
  {
    name: "Afterpay",
    logo: (
      <img src={AfterpayLogo} alt="Afterpay Logo" className="h-10 md:h-14 max-w-full" />
    ),
  },
  
  {
    name: "Visa",
    logo: (
      <img src={VisaLogo} alt="Visa Logo" className="h-4 md:h-6 max-w-full" />
    ),
  },
  {
    name: "MasterCard",
    logo: (
      <img src={MasterCard} alt="MasterCard Logo" className="h-10 md:h-14 max-w-full" />
    ),
  },
  {
    name: "American Express",
    logo: (
      <img src={AmericanExpress} alt="American Express Logo" className="h-10 md:h-12 max-w-full" />
    ),
  }
];

type PaymentMethodsType = (typeof paymentMethods)[number];

interface PaymentMethodsProps {
  paymentMethods?: PaymentMethodsType[];
}

export default function PaymentMethods({
  paymentMethods: methods = paymentMethods,
}: PaymentMethodsProps) {
  return (
    <div
      className={cn(
        "grid grid-cols-5 gap-2 sm:flex sm:justify-between sm:gap-4",
        methods.length === 3 && "sm:justify-center sm:gap-8"
      )}
    >
      {methods.map((method) => (
        <PaymentMethod key={method.name} method={method} />
      ))}
    </div>
  );
}

function PaymentMethod({ method }: { method: PaymentMethodsType }) {
  const card = (
    <div
      className={cn(
        "bg-white rounded-lg h-10 w-full sm:h-14 sm:w-32 md:h-[72px] md:w-36 flex justify-center items-center shadow-md relative opacity-60",
        method.link && "hover:opacity-90"
      )}
    >
      {method.logo}
    </div>
  );

  return method.link ? (
    <Link to={method.link} target="_blank" rel="noopener noreferrer">
      {card}
    </Link>
  ) : (
    card
  );
}
